// Shopify商品リストページ用 Buyback保証表示スクリプト (API統合版 - バッチ処理対応)
(function() {
  'use strict';

  const USE_GREEN_MARK = true;
  
  // DAWN
  const PRODUCT_CARD_SELECTOR = '.card-wrapper.product-card-wrapper'; // 商品カードのセレクタ（より具体的に）
  const CARD_LINK_SELECTOR = '.card__information a'; // 商品カードのリンクセレクタ
  const CARD_INFORMATION_SELECTOR = '.card__information'; // 商品カードの情報セクションセレクタ
  const CARD_CONTENT_SELECTOR = '.card > .card__content:last-of-type'; // カードの2つ目のcard__contentセレクタ
  const SPIXN_BASE_FONT_SIZE = 24.8; // カスタムベースフォントサイズ（通常16pxより大きく設定）
  
  // BEYOND
  // const PRODUCT_CARD_SELECTOR = '.product-card--root'; // 商品カードのセレクタ
  // const CARD_LINK_SELECTOR = 'a';
  // const CARD_INFORMATION_SELECTOR = '.product-card--details'; // 商品カードの情報セクションセレクタ
  // const SPIXN_BASE_FONT_SIZE = 16; // カスタムベースフォントサイズ（通常16pxより大きく設定）

  let DEBUG_MODE = false; // true: デバッグモード, false: 通常モード（本番環境ではfalse）
  let log = DEBUG_MODE ? console.log : () => {};
  
  const FONT_SIZE_RATIO = SPIXN_BASE_FONT_SIZE / 16;
  
  // ヘルパー関数：rem値をスケールされたcalc()に変換
  function calcSize(size) {
    return `calc(${size} * ${FONT_SIZE_RATIO})`;
  }

// === API関連の設定と関数 ===
// API Base URL: initialize関数の引数で設定可能（dev/staging/prod）
let API_BASE_URL = 'https://ieyxoq7t4c.execute-api.ap-northeast-1.amazonaws.com/dev';
const API_TIMEOUT = 10000; // 10秒
const DEFAULT_HEADERS = {
	'Content-Type': 'application/json',
	'Accept': 'application/json'
};

// SPIXN API設定オブジェクト
const SPIXN_CONFIG = {
	USE_API: true,                    // API使用フラグ
	ENABLE_CACHE: true,               // キャッシュ使用フラグ
	FALLBACK_TO_LOCAL: false,         // ローカルデータフォールバック（常にfalse）
	DEBUG_MODE: false,                // デバッグモード
	API_TIMEOUT: 10000,               // APIタイムアウト（ミリ秒）
	CACHE_TTL: 5 * 60 * 1000,        // キャッシュTTL（5分）
	MAX_RETRIES: 3,                   // 最大リトライ回数
	RETRY_DELAY: 1000,                // リトライ遅延（ミリ秒）
	BATCH_SIZE: 10                    // バッチ処理サイズ
};

// Shop ID管理用のグローバル変数
let SHOP_ID = null;

/**
 * API Base URLを取得
 * @returns {string} API Base URL
 */
function getApiBaseUrl() {
	return API_BASE_URL;
}

/**
 * API Base URLを設定
 * @param {string} baseUrl - API Base URL
 */
function setApiBaseUrl(baseUrl) {
	if (baseUrl && typeof baseUrl === 'string') {
		API_BASE_URL = baseUrl;
		log('[SPIXN] API Base URL set:', baseUrl);
	}
}

  // キャッシュ管理
  const buybackCache = new Map();

  /**
   * Shop IDを取得
   * @returns {string|null} Shop ID
   */
  function getShopId() { 
    return SHOP_ID; 
  }

  /**
   * Shop IDを設定
   * @param {string} shopId - Shop ID
   */
  function setShopId(shopId) { 
    SHOP_ID = shopId; 
  }

  /**
   * Shop IDの形式を検証
   * @param {string} shopId - Shop ID
   * @returns {boolean} 検証結果
   */
  function validateShopId(shopId) {
    if (!shopId || typeof shopId !== 'string') {
      return false;
    }
    
    // .myshopify.com形式のチェック
    const shopifyDomainPattern = /^[a-zA-Z0-9\-]+\.myshopify\.com$/;
    return shopifyDomainPattern.test(shopId);
  }

  /**
   * 共通API呼び出し関数
   * @param {string} endpoint - APIエンドポイント
   * @param {Object} params - クエリパラメータ
   * @param {Object} options - 追加オプション
   * @returns {Promise<Object>} APIレスポンス
   */
  async function callSpixnAPI(endpoint, params = {}, options = {}) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT);

    try {
      const url = new URL(`${API_BASE_URL}${endpoint}`);
      
      // パラメータをクエリストリングに追加
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          url.searchParams.append(key, params[key]);
        }
      });

      log('[SPIXN] API call:', url.toString());

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          ...DEFAULT_HEADERS,
          ...options.headers
        },
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`API call failed: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      log('[SPIXN] API response:', data);
      
      return data;
    } catch (error) {
      clearTimeout(timeoutId);
      
      if (error.name === 'AbortError') {
        throw new Error('API call timeout');
      }
      
      console.error('[SPIXN] API call error:', error);
      throw error;
    }
  }

  /**
   * リトライ可能なエラーかどうかを判定
   * @param {Error} error - エラーオブジェクト
   * @returns {boolean} リトライ可能かどうか
   */
  function isRetryableError(error) {
    // ネットワークエラーやタイムアウトはリトライ可能
    if (error.name === 'AbortError' || error.message.includes('timeout')) {
      return true;
    }
    
    // 5xx系エラーはリトライ可能
    if (error.message.includes('50')) {
      return true;
    }
    
    // 4xx系エラーはリトライしない
    return false;
  }

  /**
   * リトライ機能付きAPI呼び出し関数
   * @param {string} endpoint - APIエンドポイント
   * @param {Object} params - クエリパラメータ
   * @param {Object} options - 追加オプション
   * @returns {Promise<Object>} APIレスポンス
   */
  async function callSpixnAPIWithRetry(endpoint, params = {}, options = {}) {
    const maxRetries = options.maxRetries || SPIXN_CONFIG.MAX_RETRIES;
    const retryDelay = options.retryDelay || SPIXN_CONFIG.RETRY_DELAY;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        return await callSpixnAPI(endpoint, params, options);
      } catch (error) {
        if (attempt === maxRetries) {
          throw error;
        }

        // リトライ可能なエラーかチェック
        if (isRetryableError(error)) {
          log(`[SPIXN] API call failed (attempt ${attempt}/${maxRetries}), retrying...`);
          await new Promise(resolve => setTimeout(resolve, retryDelay * attempt));
        } else {
          throw error;
        }
      }
    }
  }

  /**
   * 商品URLから商品ハンドルを抽出
   * Shopifyの商品URLは通常 /products/{product-handle} の形式
   */
  function getProductHandleFromURL(url) {
    if (typeof url !== 'string') return null;
    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  /**
   * 商品カード要素から商品情報を抽出
   */
  function extractProductInfo(cardElement) {
    const linkElement = cardElement.querySelector(CARD_LINK_SELECTOR);
    if (!linkElement) return null;

    // 商品IDとハンドルをdata属性から直接取得（最優先）
    let productId = cardElement.getAttribute('data-product-id');
    let productHandle = cardElement.getAttribute('data-product-handle');
    
    // data属性から取得できない場合はURLから抽出
    if (!productHandle) {
      const productUrl = linkElement.getAttribute('href');
      productHandle = getProductHandleFromURL(productUrl);
    }
    
    if (!productHandle) return null;

    // 商品IDが取得できない場合は他の方法を試行
    if (!productId) {
      // 方法1: リンク要素のdata属性から取得
      productId = linkElement.getAttribute('data-product-id');
      
      // 方法2: data-product属性から取得（JSON形式の場合）
      if (!productId) {
        const productDataAttr = cardElement.getAttribute('data-product') || 
                                linkElement.getAttribute('data-product');
        if (productDataAttr) {
          try {
            const productData = JSON.parse(productDataAttr);
            productId = productData.id;
          } catch (e) {
            // JSON解析失敗は無視
          }
        }
      }
      
      // 方法3: フォーム内のhidden inputから取得
      if (!productId) {
        const hiddenInput = cardElement.querySelector('input[name="id"], input[name="product-id"]');
        if (hiddenInput) {
          productId = hiddenInput.value;
        }
      }
    }

    log(`[SPIXN] Product info extracted - Handle: ${productHandle}, ID: ${productId}`);

    return {
      productHandle,
      productId,
      cardElement,
      cardInfoElement: cardElement.querySelector(CARD_INFORMATION_SELECTOR)
    };
  }

  /**
   * バイバック対象商品IDリストを一括取得（100個単位のバッチ処理対応）
   * @param {string[]} productIds - 商品IDの配列（数値ID）
   * @returns {Promise<Set<string>>} バイバック対象商品IDのセット
   */
  async function getSupportedProductIds(productIds) {
    try {
      if (!productIds || productIds.length === 0) {
        return new Set();
      }

      // Shop IDチェック（セットされていなければ空のセットを返す）
      const shopId = getShopId();
      if (!shopId) {
        log('[SPIXN] Shop ID not set, skipping supported product IDs retrieval');
        return new Set();
      }

      // キャッシュキーを生成
      const cacheKey = `supported_products_${shopId}_${productIds.sort().join(',')}`;
      
      // キャッシュチェック
      if (SPIXN_CONFIG.ENABLE_CACHE && buybackCache.has(cacheKey)) {
        const cached = buybackCache.get(cacheKey);
        if (Date.now() - cached.timestamp < SPIXN_CONFIG.CACHE_TTL) {
          log('[SPIXN] Using cached supported products');
          return cached.data;
        }
      }

      // 商品IDを100個単位のチャンクに分割
      const BATCH_SIZE = 100;
      const batches = [];
      for (let i = 0; i < productIds.length; i += BATCH_SIZE) {
        batches.push(productIds.slice(i, i + BATCH_SIZE));
      }

      log(`[SPIXN] Total products: ${productIds.length}, Batches: ${batches.length}`);

      // 各バッチごとにAPI呼び出しを実行
      const allSupportedIds = new Set();
      
      for (let i = 0; i < batches.length; i++) {
        const batch = batches[i];
        log(`[SPIXN] Processing batch ${i + 1}/${batches.length} (${batch.length} products)`);
        
        // APIパラメータを構築（商品IDをGID形式に変換してカンマ区切りで送信）
        const gidProductIds = batch.map(id => `gid://shopify/Product/${id}`);
        const params = {
          sp_shop_id: shopId,
          product_ids: gidProductIds.join(',')
        };

        try {
          // API呼び出し（supported-products エンドポイントを使用）
          const response = await callSpixnAPIWithRetry('/shopify/buyback/supported-products', params);

          // レスポンス検証
          if (response.data && response.data.supported_product_codes) {
            if (Array.isArray(response.data.supported_product_codes)) {
              response.data.supported_product_codes.forEach(id => allSupportedIds.add(id));
              log(`[SPIXN] Batch ${i + 1}: Found ${response.data.supported_product_codes.length} supported products`);
            } else {
              console.error('[SPIXN] Invalid supported_product_codes format in batch', i + 1, ':', response.data.supported_product_codes);
            }
          }
        } catch (error) {
          console.error(`[SPIXN] Failed to fetch batch ${i + 1}/${batches.length}:`, error);
          // バッチの一部が失敗しても続行（他のバッチは処理する）
        }
      }

      // キャッシュに保存
      if (SPIXN_CONFIG.ENABLE_CACHE) {
        buybackCache.set(cacheKey, {
          data: allSupportedIds,
          timestamp: Date.now()
        });
      }

      log('[SPIXN] Total supported products loaded:', allSupportedIds.size, 'out of', productIds.length);
      return allSupportedIds;
    } catch (error) {
      console.error('[SPIXN] Failed to get supported product IDs:', error);
      return new Set();
    }
  }

  /**
   * バイバック対象商品ハンドルリストを一括取得（将来実装予定）
   * @param {string[]} productHandles - 商品ハンドルの配列
   * @returns {Promise<Set<string>>} バイバック対象商品ハンドルのセット
   */
  async function getSupportedProductHandles(productHandles) {
    // TODO: 商品ハンドルベースのAPIエンドポイントが実装されたら有効化
    console.warn('[SPIXN] getSupportedProductHandles: API endpoint not yet implemented');
    return new Set();
  }

  /**
   * Buyback保証マークを作成
   * MakeshopのinsertBBInfo()と同じスタイルを使用
   */
  function createBuybackMark() {

    const bbInfoDiv = document.createElement('div');
    bbInfoDiv.className = 'spixn-buyback-mark';
    
    // 計算済みのサイズを事前に計算
    const fontSize = (0.75 * FONT_SIZE_RATIO) + 'rem';
    const markSize = (0.8 * FONT_SIZE_RATIO) + 'rem';
    const symbolFontSize = (0.6 * FONT_SIZE_RATIO) + 'rem';
    
    // Makeshopと同じスタイルを適用
    Object.assign(bbInfoDiv.style, {
      display: 'flex',
      justifyContent: 'center',
      fontSize: fontSize,
      alignItems: 'center',
      gap: '0.1rem',
      color: '#222222',
      marginTop: '0.25rem',
      inlineSize: 'fit-content(100%)',
    });

    // const bbSymbolStyle = `
    //   background: #6C30CF;
    //   color: white;
    //   font-weight: bold;
    //   border-radius: 50%;
    //   width: ${markSize};
    //   height: ${markSize};
    //   text-align: center;
    //   line-height: ${markSize};
    //   font-size: ${symbolFontSize};
    //   display: inline-flex;
    //   align-items: center;
    //   justify-content: center;`;

    const midDiv = document.createElement('div');
    Object.assign(midDiv.style, {
      flex: "0 1 auto",
      minWidth: 0,
      textAlign: "center",
      whiteSpace: "normal",
      wordBreak: "keep-all"
    });
    midDiv.innerHTML = `${createSpixnMarkCircleSVG(USE_GREEN_MARK)}バイバック保証対象`;

    bbInfoDiv.appendChild(midDiv);

    return bbInfoDiv;
  }

  /**
   * Buyback保証マークを商品カードに挿入
   */
  function insertBuybackMark(cardElement) {
    // 既にマークが存在する場合は何もしない
    if (cardElement.querySelector('.spixn-buyback-mark')) {
      return;
    }

    const buybackMark = createBuybackMark();
    
    // カードの最下部コンテンツ要素を取得
    const cardContent = cardElement.querySelector(CARD_CONTENT_SELECTOR);
    if (cardContent) {
      // 挿入優先順位:
      // 1. ボタンコンテナの内部最後（Grid Layout対応）
      // 2. card__badgeの直前
      // 3. card-informationの後
      // 4. 最後に追加
      
      // ボタンコンテナを複数パターンで検索し、内部の最後に挿入
      const quickAddDiv = cardContent.querySelector('.quick-add');
      const productForm = cardContent.querySelector('product-form');
      const quickAddBulk = cardContent.querySelector('quick-add-bulk');
      
      if (quickAddDiv) {
        // quick-add div の内部最後に挿入（Grid Layout対応）
        quickAddDiv.prepend(buybackMark);
        log('Buyback mark inserted inside .quick-add');
      } else if (productForm) {
        // product-form の内部最後に挿入
        productForm.appendChild(buybackMark);
        log('Buyback mark inserted inside product-form');
      } else if (quickAddBulk) {
        // quick-add-bulk の内部最後に挿入
        quickAddBulk.prepend(buybackMark);
        log('Buyback mark inserted inside quick-add-bulk');
      } else {
        // ボタンがない場合のフォールバック処理（related-products対応）
        const cardInformation = cardContent.querySelector('.card-information');
        const cardBadge = cardContent.querySelector('.card__badge');
        
        if (cardInformation) {
          // card-informationの内部最後に挿入（価格情報の後）
          cardInformation.appendChild(buybackMark);
          log('Buyback mark inserted inside .card-information (no button fallback)');
        } else if (cardBadge) {
          // card__badgeの直前に挿入
          cardContent.insertBefore(buybackMark, cardBadge);
          log('Buyback mark inserted before .card__badge (no button fallback)');
        } else {
          // 最終フォールバック: cardContentの最後に追加
          cardContent.appendChild(buybackMark);
          log('Buyback mark appended to cardContent (final fallback)');
        }
      }
    } else {
      // フォールバック: card__information要素に追加
      const cardInfo = cardElement.querySelector(CARD_INFORMATION_SELECTOR);
      if (cardInfo) {
        cardInfo.appendChild(buybackMark);
        log('Buyback mark inserted in fallback cardInfo');
      }
    }
    
    log('Buyback mark inserted for product card');
  }

  /**
   * 商品リストページでBuyback保証マークを表示（効率化版）
   */
  async function displayBuybackMarks() {
    // 商品カード要素を取得（Shopifyの一般的なセレクタ）
    const productCards = document.querySelectorAll(PRODUCT_CARD_SELECTOR);
    
    log('Found product cards:', productCards.length);

    if (productCards.length === 0) {
      log('No product cards found');
      return;
    }

    // 全商品の情報を抽出
    const productInfos = [];
    const productHandles = [];
    const productIds = [];

    productCards.forEach(cardWrapper => {
      const productInfo = extractProductInfo(cardWrapper);
      if (productInfo) {
        productInfos.push(productInfo);
        productHandles.push(productInfo.productHandle);
        if (productInfo.productId) {
          productIds.push(productInfo.productId);
        }
      }
    });

    if (productHandles.length === 0) {
      log('No valid product handles found');
      return;
    }

    log('Product handles extracted:', productHandles);
    log('Product IDs extracted:', productIds);

    try {
      let supportedItems = new Set();
      let useIds = false;

      // 商品IDが取得できた場合は既存のAPIを使用
      if (productIds.length > 0 && productIds.length === productInfos.length) {
        log('[SPIXN] Using product IDs for API call');
        supportedItems = await getSupportedProductIds(productIds);
        useIds = true;
      } else {
        // 商品IDが取得できない場合は一時的にスキップ
        // TODO: 商品ハンドルベースのAPIエンドポイントが実装されたら有効化
        log('[SPIXN] Product IDs not available, skipping buyback marks for now');
        console.warn('[SPIXN] Product list page: Cannot get all product IDs, skipping buyback marks');
        return;
      }
      
      if (supportedItems.size === 0) {
        log('[SPIXN] No supported products found');
        return;
      }

      log('[SPIXN] Supported products:', Array.from(supportedItems));

      // バイバック対象商品にマークを表示
      productInfos.forEach(productInfo => {
        const identifier = useIds ? productInfo.productId : productInfo.productHandle;
        if (identifier && supportedItems.has(identifier)) {
          if (productInfo.cardElement) {
            insertBuybackMark(productInfo.cardElement);
            log(`[SPIXN] Buyback mark added for product: ${identifier}`);
          }
        }
      });

      log(`[SPIXN] Buyback marks displayed for ${supportedItems.size} products`);
      
    } catch (error) {
      console.error('[SPIXN] Error in displayBuybackMarks:', error);
    }
  }

  /**
   * SPIXN API機能の初期化
   * @param {string} shopId - Shop ID
   */
  async function initializeSpixnAPI(shopId) {
    try {
      log('[SPIXN] Initializing SPIXN API...');
      
      // Shop IDを設定
      if (shopId && validateShopId(shopId)) {
        setShopId(shopId);
        log('[SPIXN] Shop ID set:', shopId);
        log('[SPIXN] SPIXN API initialization completed');
        return true;
      } else {
        console.warn('[SPIXN] Shop ID not available or invalid:', shopId);
        return false;
      }
    } catch (error) {
      console.error('[SPIXN] SPIXN API initialization failed:', error);
      return false;
    }
  }

  // デバウンス関数
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // デバウンスされたマーク表示関数
  const debouncedDisplayBuybackMarks = debounce(displayBuybackMarks, 500);

/**
 * 数値IDをShopify GID形式に変換
 * @param {string|number} id - 数値ID
 * @param {string} type - リソースタイプ（'Product' または 'ProductVariant'）
 * @returns {string} GID形式のID
 */
function convertToShopifyGID(id, type) {
	if (!id) return null;
	const numericId = id.toString();
	return `gid://shopify/${type}/${numericId}`;
}

/**
 * Shopify GIDから数値IDを抽出
 * @param {string} gid - GID形式のID
 * @returns {string|null} 数値ID
 */
function extractNumericIdFromGID(gid) {
	if (!gid || typeof gid !== 'string') return null;
	const match = gid.match(/gid:\/\/shopify\/\w+\/(\d+)/);
	return match ? match[1] : null;
}

/**
 * 現在の商品IDを取得（GID形式で返す）
 * @returns {string|null} 商品ID（GID形式）
 */
function getCurrentProductId() {
	try {
		// 方法1: ShopifyAnalyticsから取得
		const productData = window.ShopifyAnalytics?.meta?.product;
		if (productData?.id) {
			const numericId = productData.id.toString();
			return convertToShopifyGID(numericId, 'Product');
		}

		// 方法2: フォームのhidden inputから取得
		const productIdInput = document.querySelector('input[name="product-id"]');
		if (productIdInput?.value) {
			return convertToShopifyGID(productIdInput.value, 'Product');
		}

		// 方法3: data属性から取得
		const productElement = document.querySelector('[data-product-id]');
		if (productElement) {
			const productId = productElement.getAttribute('data-product-id');
			if (productId) {
				return convertToShopifyGID(productId, 'Product');
			}
		}

		// 方法4: URLから商品ハンドルを取得（最後の手段）
		const pathMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
		if (pathMatch) {
			const handle = pathMatch[1];
			// ハンドルから商品IDを取得する処理が必要
			// この部分は環境に依存するため、実装時に調整が必要
			console.warn('[SPIXN] Product ID not found, handle detected:', handle);
		}

		console.error('[SPIXN] Product ID not found');
		return null;
	} catch (error) {
		console.error('[SPIXN] Failed to get product ID:', error);
		return null;
	}
}

  // 動的コンテンツの変更を監視（無限スクロールやAjax読み込み対応）
  const observer = new MutationObserver(function(mutations) {
    // 商品詳細ページでは監視を停止
    if (!isProductListPage()) {
      log('[SPIXN] Not a product list page, skipping MutationObserver update');
      return;
    }
    
    let shouldUpdate = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // 新しい商品カードが追加された可能性をチェック
        for (let node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // 商品詳細ページの要素は除外
            if (node.matches('.product__media-item, .product__info-wrapper, variant-selects')) {
              log('[SPIXN] Product detail page element detected, skipping update');
              continue;
            }
            
            if (node.matches(PRODUCT_CARD_SELECTOR) ||
                node.querySelector(PRODUCT_CARD_SELECTOR)) {
              shouldUpdate = true;
              break;
            }
          }
        }
      }
    });
    
    if (shouldUpdate) {
      log('New product cards detected, updating バイバック marks');
      debouncedDisplayBuybackMarks();
    }
  });

  // 商品リストコンテナを監視（初期化時にページ判定を行う）
  function setupMutationObserver() {
    if (!isProductListPage()) {
      log('[SPIXN] Not a product list page, skipping MutationObserver setup');
      return;
    }
    
    const productListContainer = document.querySelector('.collection, .product-grid, .grid, main');
    if (productListContainer) {
      observer.observe(productListContainer, {
        childList: true,
        subtree: true
      });
      log('MutationObserver set up for dynamic content');
    }
  }

  /**
   * 現在のページが商品リストページかどうかを判定
   * @returns {boolean} 商品リストページの場合true
   */
  function isProductListPage() {
    // 方法1: URLパスによる判定
    const path = window.location.pathname;
    
    // 商品リストページの典型的なパス
    const productListPaths = [
      /^\/collections\/[^\/]+\/?$/,  // コレクションページ
      /^\/collections\/?$/,          // コレクション一覧
      /^\/search\/?$/,               // 検索結果ページ
      /^\/$|^\/index\/?$/,           // ホームページ
      /^\/pages\/[^\/]+\/?$/         // 商品を含む可能性のあるページ
    ];
    
    const isListPage = productListPaths.some(pattern => pattern.test(path));
    if (isListPage) {
      log('[SPIXN] Product list page detected by URL:', path);
      return true;
    }
    
    // 方法2: 商品詳細ページでもrelated-productsがある場合は処理する
    if (path.match(/\/products\/[^\/]+\/?$/)) {
      // related-productsセクションが存在するかチェック
      const relatedProducts = document.querySelector('.related-products, product-recommendations');
      if (relatedProducts) {
        log('[SPIXN] Product detail page with related products detected:', path);
        return true;
      } else {
        log('[SPIXN] Product detail page without related products, skipping product list script');
        return false;
      }
    }
    
    // 方法3: 商品リストページ特有の要素による判定
    const productListSelectors = [
      '.collection',
      '.product-grid',
      '.grid--product-grid',
      '.collection-hero',
      '.facets',
      '.related-products',
      'product-recommendations'
    ];
    
    const hasProductListElements = productListSelectors.some(selector => 
      document.querySelector(selector)
    );
    
    if (hasProductListElements) {
      log('[SPIXN] Product list page detected by DOM elements:', path);
      return true;
    }
    
    // 方法4: 商品カードの存在による判定（最終手段）
    const productCards = document.querySelectorAll(PRODUCT_CARD_SELECTOR);
    if (productCards.length >= 1) {  // 1個以上の商品カードがある場合（related-products対応）
      log('[SPIXN] Product list page detected by product card count:', productCards.length);
      return true;
    }
    
    log('[SPIXN] Not a product list page, skipping product list script');
    return false;
  }

  function createSpixnMarkCircleSVG(useGreen = false) {
    const color = useGreen ? '#1AB298' : '#6C30CF';
    return `
      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: baseline;">
      <g clip-path="url(#clip0_1427_3087)">
      <path d="M7.00123 13.0025C10.5918 13.0025 13.5025 10.0918 13.5025 6.50123C13.5025 2.9107 10.5918 0 7.00123 0C3.4107 0 0.5 2.9107 0.5 6.50123C0.5 10.0918 3.4107 13.0025 7.00123 13.0025Z" fill="${color}"/>
      <path d="M3.96566 9.09757C4.42183 9.55602 5.04143 9.81448 5.68816 9.8161H5.71277C6.06158 9.80932 6.40539 9.73191 6.72344 9.58853C7.04149 9.44516 7.32717 9.2388 7.56323 8.98192L7.60753 8.9327L7.87575 8.63496L9.59825 9.83579H11.3774L9.04951 8.21171L5.78905 5.92816L5.01146 5.3868C4.9124 5.31079 4.83161 5.21357 4.77501 5.10227C4.71841 4.99097 4.68744 4.86841 4.68437 4.74359C4.6813 4.61876 4.70622 4.49483 4.75728 4.38088C4.80834 4.26694 4.88426 4.16587 4.97947 4.08508C5.19671 3.89346 5.47725 3.78914 5.76691 3.79226C6.36486 3.79226 6.85209 4.20812 6.85455 4.71995C6.85491 4.77537 6.84913 4.83067 6.83732 4.88482L6.81763 4.9611C6.79964 5.01287 6.77742 5.06307 6.7512 5.1112C6.71941 5.16848 6.68146 5.22212 6.638 5.27114L6.48298 5.45324L7.32209 6.0389L7.41067 5.93801C7.49933 5.83491 7.57687 5.72273 7.64198 5.60334C7.70324 5.4932 7.75273 5.3769 7.78962 5.25638L7.82161 5.14565V5.11858C7.85105 4.98608 7.8659 4.85076 7.8659 4.71503C7.8659 3.64215 6.91606 2.77351 5.75952 2.77351C5.21493 2.76899 4.68831 2.96823 4.28309 3.3321C4.08469 3.50684 3.92586 3.7219 3.81722 3.96293C3.70859 4.20396 3.65265 4.46541 3.65315 4.72979C3.65661 5.01058 3.7227 5.28706 3.84658 5.53908C3.97046 5.79109 4.14901 6.01228 4.36922 6.18653L4.38398 6.19884L7.01941 8.037L6.8324 8.24617C6.68824 8.41205 6.51126 8.54624 6.31262 8.64027C6.11398 8.73429 5.898 8.78611 5.67832 8.79245C5.30467 8.79231 4.94597 8.64565 4.67926 8.38397C4.48976 8.18669 4.38319 7.92421 4.38152 7.65067V7.11177H3.36524V7.64082C3.36468 7.91118 3.41743 8.179 3.52045 8.42896C3.62348 8.67892 3.77476 8.90612 3.96566 9.09757Z" fill="white"/>
      <path d="M9.25796 5.54199L8.24414 6.68131L9.08325 7.26942L10.6212 5.54199H9.25796Z" fill="white"/>
      <path d="M10.5423 4.91367C10.9065 4.91367 11.2018 4.61842 11.2018 4.2542C11.2018 3.88998 10.9065 3.59473 10.5423 3.59473C10.1781 3.59473 9.88281 3.88998 9.88281 4.2542C9.88281 4.61842 10.1781 4.91367 10.5423 4.91367Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_1427_3087">
      <rect width="13" height="13" fill="white" transform="translate(0.5)"/>
      </clipPath>
      </defs>
      </svg>
    `;

  }  


  /**
   * メイン初期化関数
   * @param {string} shopId - Shop ID
   * @param {string} apiBaseUrl - API Base URL（オプション）
   * @param {Object} options - 設定オプション
   * @param {boolean} options.debugMode - デバッグモード（デフォルト: false）
   */
  async function initialize(shopId, apiBaseUrl, options = {}) {
    try {
      // DEBUG_MODEの設定
      if (typeof options.debugMode !== 'undefined') {
        DEBUG_MODE = options.debugMode;
        log = DEBUG_MODE ? console.log : () => {};
      }
      
      log('[SPIXN] ShopifyBuybackProductList initializing...', { debugMode: DEBUG_MODE });
      
      // ページ判定: 商品リストページでない場合は処理を停止
      if (!isProductListPage()) {
        log('[SPIXN] Not a product list page, initialization skipped');
        return false;
      }
      
      // API Base URLが指定されている場合は設定
      if (apiBaseUrl) {
        setApiBaseUrl(apiBaseUrl);
      }
      
      // SPIXN APIを初期化
      const initialized = await initializeSpixnAPI(shopId);
      if (!initialized) {
        console.warn('[SPIXN] SPIXN API initialization failed');
        return false;
      }
      
      // バイバックマークを表示
      await displayBuybackMarks();
      
      // MutationObserverをセットアップ
      setupMutationObserver();
      
      log('[SPIXN] ShopifyBuybackProductList initialization completed');
      return true;
    } catch (error) {
      console.error('[SPIXN] ShopifyBuybackProductList initialization failed:', error);
      return false;
    }
  }


  // グローバルに公開（外部から呼び出し用）
  window.ShopifyBuybackProductList = {
    initialize,                    // メイン実行関数（shopId, apiBaseUrlを引数で受け取る）
    displayBuybackMarks,          // バイバックマーク表示
    getSupportedProductIds,       // バイバック対象商品取得（数値ID版）
    getSupportedProductHandles,   // バイバック対象商品取得（ハンドル版）
    getShopId,                    // Shop ID取得
    setShopId,                    // Shop ID設定
    getApiBaseUrl,                // API Base URL取得
    setApiBaseUrl                 // API Base URL設定
  };

})();
